import { IconThinArrowDown, Typography } from '@grammarly/badger-ui'
import cn from 'classnames'
import React from 'react'
import styles from './accordion-button.module.scss'

export interface AccordionButton {
  isActive: boolean
  content: string
  id: string
  associatedContentId: string
  onClick: () => void
  className?: string | null
}

export const AccordionButton: React.FC<AccordionButton> = ({
  id,
  isActive,
  content,
  onClick,
  associatedContentId,
  className,
}) => {
  return (
    <button
      className={cn(styles.button, className, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
      id={id}
      aria-expanded={isActive}
      aria-controls={associatedContentId}
    >
      <Typography.HS className={styles.content} as="h4">
        {content}
      </Typography.HS>
      <span
        className={cn(styles.icon, {
          [styles.rotate]: isActive,
        })}
        aria-hidden
      >
        <IconThinArrowDown />
      </span>
    </button>
  )
}
